var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-lg leading-6 font-medium text-gray-900"},[_vm._v(" Totais ")]),_c('div',{staticClass:"mt-5"},[_c('LastTwelveMonthsChart')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }